import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-error-page',
  imports: [],
  templateUrl: './custom-error-page.component.html',
  styleUrl: './custom-error-page.component.css'
})
export class CustomErrorPageComponent {

}
